export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-900 text-background-200 py-12 md:py-16 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <span className="font-heading text-xl font-bold text-background-50 tracking-tight">
              Basetao <span className="italic font-normal text-background-300">Sheet</span>
            </span>
            <p className="text-foreground-400 text-sm mt-3 leading-relaxed">
              The most comprehensive English resource for Basetao Spreadsheet. Helping shoppers worldwide make smarter decisions since 2024.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              <li><a href="#what-is" className="text-foreground-400 text-sm hover:text-background-100 transition-colors">What Is Basetao Spreadsheet</a></li>
              <li><a href="#why-users" className="text-foreground-400 text-sm hover:text-background-100 transition-colors">Why Users Search</a></li>
              <li><a href="#featured-guides" className="text-foreground-400 text-sm hover:text-background-100 transition-colors">Featured Guides</a></li>
              <li><a href="#categories" className="text-foreground-400 text-sm hover:text-background-100 transition-colors">Product Categories</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">Resources</h4>
            <ul className="space-y-2.5">
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-foreground-400 text-sm hover:text-background-100 transition-colors">Main Website</a></li>
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-foreground-400 text-sm hover:text-background-100 transition-colors">Shop Now</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">Legal</h4>
            <ul className="space-y-2.5">
              <li><a href="#safety" className="text-foreground-400 text-sm hover:text-background-100 transition-colors">Safety Disclaimer</a></li>
              <li><span className="text-foreground-500 text-sm">Independent Resource</span></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; {currentYear} Basetao Sheet. All rights reserved. This is an independent educational resource.
          </p>
          <p className="text-foreground-500 text-xs">
            Not affiliated with any specific brand or platform.
          </p>
        </div>
      </div>
    </footer>
  );
}